export const es = {
  EW_IMAGE: {
    HEADER: 'Biblioteca de imágenes',
    SELECT_IMAGE: 'Seleccionar imagen',
    RECOMMENDED_SIZE: 'Tamaño de imagen recomendado',

    DRAG_DROP_MESSAGE: 'Click or drag file to this area to upload',
    FILE_SIZE: 'File size limit is 10MB per file',
    MY_IMAGE: 'My Image',
    UNSPLASH: 'Unsplash',
    DONE: 'Done',
    CANCEL: 'Cancel',
    EMPTY_IMAGES_SCREEN_MESSAGE:"No images available yet",
    EMPTY_IMAGES_SCREEN_SUB_MESSAGE:"Please add images in library to continue..",
    NO_MATCH:"Nothing matches with your search",
    NO_MATCH_MESSAGES:"Try something new."
  },
};
